export default __webpack_public_path__ + "static/media/bloodCount.7631c451.svg";